module.exports = __webpack_public_path__ + "img/final-logo.0c102b4b.gif";